import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, VStack, Text } from "@chakra-ui/react";
import { $Routes } from "@routes";
import { Breadcrumb } from "@components";
import { hasDemoGuestToken } from "@utils/guestDemo";
import ActivityList from "./ActivityList";
import AgendaListItem from "./AgendaListItem";

const PastAgendaView = ({
  agenda: currentAgenda,
  activities,
  isLoading: isAgendaLoading,
}) => {
  const navigate = useNavigate();
  const { agendaId } = useParams();

  // A guest demo has no JWT, so the authed /pro/reports route would bounce it to
  // /login. Route guests to the public /demo/:agendaId/report demo route instead.
  const handleViewEReport = () => {
    if (hasDemoGuestToken()) {
      navigate(`/demo/${agendaId}/report?demo=true`);
      return;
    }
    navigate(`${$Routes.reportDetailPage}/${agendaId}`);
  };

  const formatAgendaDate = () => {
    if (!currentAgenda?.createdAt) return "";
    const date = new Date(currentAgenda.createdAt);
    return `${date.getMonth() + 1}/${date.getDate()}`;
  };

  const breadcrumbItems = [
    {
      title: "Agenda",
      onClick: () => navigate($Routes.allAgendaPage),
      testId: "agenda-header-back",
    },
    {
      title: currentAgenda?.title
        ? `${formatAgendaDate()} ${currentAgenda.title}`
        : "Loading...",
      testId: "agenda-title",
    },
  ];

  return (
    <Box
      bg="#FAFAFB"
      position="relative"
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <VStack spacing={4} align="stretch" flex="1" minH="0">
        {/* Header with Breadcrumb */}
        <Breadcrumb items={breadcrumbItems} />

        {/* Agenda Summary Card - using AgendaListItem with hideTitle */}
        {/* TODO: Implement menu actions for past agenda view */}
        <AgendaListItem
          id={currentAgenda?._id}
          title={currentAgenda?.title}
          hideTitle={true}
          hideMenu={true}
          isPastAgenda={true}
          impactScore={currentAgenda?.impactScore}
          eScore={currentAgenda?.eScore}
          meetingType={currentAgenda?.meetingType}
          blueprint={currentAgenda?.blueprint}
          onMenuToggle={() => {}}
        />

        {/* Activity List with Accordions */}
        <Box flex="1" minH="0" overflowY="auto">
          <ActivityList
            agendaId={agendaId}
            currentAgenda={currentAgenda}
            isLoading={isAgendaLoading}
            isPastAgenda={true}
          />
        </Box>

        {/* View E-Report Button */}
        <Box
          bg="#4C47CC"
          borderRadius="10px"
          p={3}
          cursor="pointer"
          onClick={handleViewEReport}
          _hover={{ bg: "#433AC9" }}
        >
          <Text
            color="white"
            fontSize="13px"
            fontWeight="700"
            textAlign="center"
          >
            View E-Report
          </Text>
        </Box>
      </VStack>
    </Box>
  );
};

export default PastAgendaView;
